import { IsNotEmpty } from "class-validator";

export class CreateOneRosterSettingsDto {
    @IsNotEmpty({ message: "District ID is required" })
    districtId: string;

    @IsNotEmpty({ message: "Auth URL is required" })
    authUrl: string;

    @IsNotEmpty({ message: "OneRoster URL is required" })
    oneRosterUrl: string;

    @IsNotEmpty({ message: "Client ID is required" })
    clientId: string;

    @IsNotEmpty({ message: "Client Secret is required" })
    clientSecret: string;
}